import { DashboardContainer } from './styles';

import Button from '../../components/Button';
import { logout, getUserId, getToken } from '../../services/auth';

function Dashboard() {
  function createMinisite() {
    const user_id = getUserId();
    const token = getToken();

    window.open(`http://localhost:3000?user_id=${user_id}&token=${token}`);
  }

  return (
    <DashboardContainer>
      <h1>Dashboard</h1>
      <br /><br />
      <Button onClick={() => logout({ redirect: true })}>
        Sair
      </Button>

      <br /><br />

      <Button onClick={createMinisite}>
        Criar seu Minisite.delivery
      </Button>
    </DashboardContainer>
  );
};

export default Dashboard;
